import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const PermissionsDomainName_UnresolvedCodesUI = 'Unresolved Codes UI';
export const PermissionKeys_UnresolvedCodesUI = generateKeyNamesByAccessLevel(PermissionsDomainName_UnresolvedCodesUI, defaultUIAccessLevels);
//# sourceMappingURL=ui.js.map